<template>
  <label
    :class="classes"
    @mouseover.stop='isHover = true'
    @mouseleave='isHover = false'
    @click.stop="$emit('click')">
    <slot/>
  </label>
</template>


<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      isHover: false,
    }
  },

  computed: {
    classes() {
      return {
        'mr-3' : true,
        'disabled' : this.disabled,
        [`${this.type}`] : !this.disabled && true,
        [`${this.type}--active`] : this.active,
        [`${this.type}--hover`] : this.isHover && !this.active,
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  label
    box-shadow 0px 2px 2px rgba(0,0,0,0.29)
    font-weight bold
    text-align center
    display inline-block
    padding 0 5px
    margin 5px 5px 0 0 !important
    min-width 100px
    height 50px
    line-height 50px
    border-radius 3px
    cursor pointer
    position relative
    outline: none;
    position: relative;
    opacity: .6;

  types = {
    'ko': {
      'background-color': #c44c32,
      'box-shadow-color': #8a1c1c,
    },
    'su': {
      'background-color': #3E90C6,
      'box-shadow-color': #225f87,
    },
    'ei': {
      'background-color': #49A26E,
      'box-shadow-color': #2c5e41,
    },
    'ri': {
      'background-color': #BE8540,
      'box-shadow-color': #875b26,
    },
    'sh': {
      'background-color': #7DA551,
      'box-shadow-color': #576e3d,
    },
    'ch': {
      'background-color': #7DA551,
      'box-shadow-color': #576e3d,
    },
    're': {
      'background-color': #7DA551,
      'box-shadow-color': #576e3d,
    },
    'mi': {
      'background-color': #7DA551,
      'box-shadow-color': #576e3d,
    },
    'gi': {
      'background-color': #3d84a8,
      'box-shadow-color': #184d68,
    },
    'za': {
      'background-color': #3d84a8,
      'box-shadow-color': #184d68,
    },
    'se': {
      'background-color': #3d84a8,
      'box-shadow-color': #184d68,
    },
    'en': {
      'background-color': #3d84a8,
      'box-shadow-color': #184d68,
    },
    'jo': {
      'background-color': #3d84a8,
      'box-shadow-color': #184d68,
    },
    'ka': {
      'background-color': #d74443,
      'box-shadow-color': #a71211,
    },
    'ss': {
      'background-color': #d74443,
      'box-shadow-color': #a71211,
    },
    'is': {
      'background-color': #d74443,
      'box-shadow-color': #a71211,
    },
    'sk': {
      'background-color': #d74443,
      'box-shadow-color': #a71211,
    },
    'kc': {
      'background-color': #d74443,
      'box-shadow-color': #a71211,
    },
    'ht': {
      'background-color': #e55f34,
      'box-shadow-color': #742a12,
    },
    'ho': {
      'background-color': #e55f34,
      'box-shadow-color': #742a12,
    },
    'ta': {
      'background-color': #e55f34,
      'box-shadow-color': #742a12,
    },
    'tr': {
      'background-color': #e55f34,
      'box-shadow-color': #742a12,
    },
  }

  for type, values in types
    .{type}
      background-color values['background-color'];
      color white
      border-radius 10px
      box-shadow 0px 6px values['box-shadow-color'];

      &--active
        box-shadow: 0 0 values['box-shadow-color'];
        top: 6px;
        opacity: 1;

      &--hover
        box-shadow: 0 4px values['box-shadow-color'];
        top: 2px;
        opacity: 1;

  .disabled
    background-color: #959595;
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 #5c5c5c;
    top: 6px;
</style>
